<iframe *ngIf="emailHtml$ | async as doc; else loadingTemplate" sandbox="allow-popups allow-popups-to-escape-sandbox" class="email-iframe" [srcdoc]="doc"></iframe>
<ng-template #loadingTemplate>
    <div class="loading-wrapper">
        <app-loading></app-loading>
    </div>
</ng-template>
